import React from 'react';
import './About.css';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import Button from '../components/Button';
import principlesImage from '../assets/About_home.webp';
import principlesImageM from '../assets/About_home-800w.webp';

interface AboutProps { }

export const About: React.FC<AboutProps> = () => {
  return (
    <section className="section about-section" id="about">
      {/* Dynamic ambient grid overlay & color meshes for high-tech look */}
      <div className="about-mesh-bg" aria-hidden="true" />
      <div className="about-glow-orb-1" aria-hidden="true" />
      <div className="about-glow-orb-2" aria-hidden="true" />

      <div className="container relative-z">
        <div className="about-values-container">
          <div className="about-intro-block reveal-on-scroll">
            <div className="about-intro-header">
              <h2 className="about-headline">
                Beyond Software. We Build Business Intelligence.
              </h2>
            </div>

            <div className="values-image-panel reveal-on-scroll delay-1">
              <div className="image-panel-neon-edge" />
              <img
                loading="lazy"
                decoding="async"
                src={principlesImage}
                srcSet={`${principlesImageM} 800w, ${principlesImage} 1600w`}
                sizes="(max-width: 768px) 100vw, 50vw"
                alt="Vivify Infrastructure & Engineering"
                className="image-panel-img"
                title="Vivify Soft Tech"
              />
              <div className="image-panel-overlay" />
            </div>

            <div className="about-intro-content">
              <p className="about-lead-text">
                Every business is unique. We combine AI, domain expertise, and process understanding to create scalable digital solutions that solve real business challenges.
              </p>
              <div className="about-preview-cta">
                <Link to="/about">
                  <Button variant="primary" size="md" icon={<ArrowRight size={16} />} className="about-hero-primary-btn">
                    Learn More About Us
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
